import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useIngredientCategories } from '../hooks/useIngredientCategories';

interface IngredientsFiltersProps {
  filters: {
    search: string;
    category: string;
  };
  onFiltersChange: (filters: any) => void;
}

export const IngredientsFilters: React.FC<IngredientsFiltersProps> = ({
  filters,
  onFiltersChange
}) => {
  const { categoryOptions, loading: categoriesLoading } = useIngredientCategories();

  const categories = [
    { value: 'all', label: 'Todas las categorías' },
    ...categoryOptions
  ];

  return (
    <div className="bg-white rounded-lg border p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Búsqueda */}
        <div className="lg:col-span-2">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <Input
              placeholder="Buscar insumos..."
              value={filters.search}
              onChange={(e) => onFiltersChange({ search: e.target.value })}
              className="pl-10"
            />
          </div>
        </div>

        {/* Categoría */}
        <div>
          <Select
            value={filters.category}
            onValueChange={(value) => onFiltersChange({ category: value })}
            disabled={categoriesLoading}
          >
            <SelectTrigger>
              <SelectValue placeholder={categoriesLoading ? "Cargando categorías..." : "Categoría"} />
            </SelectTrigger>
            <SelectContent>
              {categories.map((category) => (
                <SelectItem key={category.value} value={category.value}>
                  {category.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};